(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["navigation-footer"]) return;
  try {
    
const updateFooterNewsletterButton = () => {
  document.querySelectorAll('.navigation-footer__wrapper[data-newsletter-button-text]').forEach((footer) => {
    const buttonText = footer.dataset.newsletterButtonText.trim()
    if (!buttonText) return
    document.querySelectorAll('.shopify-section-group-main-footer.form-email-signup input[type="submit"]').forEach((button) => {
      button.value = buttonText
      button.setAttribute('aria-label', buttonText)
    })
  })
}
updateFooterNewsletterButton()
document.addEventListener('shopify:section:load', updateFooterNewsletterButton)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["starter-kit-landing"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.sk-starter').forEach((section) => {
    const toggles = section.querySelectorAll('[data-sk-upsell-toggle]');
    const fields = section.querySelectorAll('[data-sk-upsell-field]');
    const form = section.querySelector('.sk-starter__form');
    let submittingAfterBag = false;

    toggles.forEach((toggle) => {
      toggle.addEventListener('change', () => {
        toggles.forEach((otherToggle) => {
          otherToggle.checked = toggle.checked;
        });
        fields.forEach((field) => {
          field.disabled = !toggle.checked;
        });
      });
    });

    form?.addEventListener('submit', async (event) => {
      if (submittingAfterBag || !section.querySelector('[data-sk-upsell-toggle]:checked')) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      const button = event.submitter;
      if (button) button.disabled = true;
      try {
        const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(fields[0].value), quantity: 1 }] })
        });
        if (!response.ok) throw new Error('Gift bag could not be added');
        submittingAfterBag = true;
        if (button) button.disabled = false;
        if (button) form.requestSubmit(button);
        else form.requestSubmit();
        submittingAfterBag = false;
      } catch (error) {
        if (button) button.disabled = false;
        window.alert('We could not add the gift bag. Please try again.');
      }
    }, true);
  });

  } catch(e) { console.error(e); }
})();
})();
